import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationPluginService } from '../../services/reservation-plugin.service';
import { ReservationPluginInfo } from 'projects/qcloud-models/reservation-plugin/reservation-plugin-info';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { ConfirmModalData } from '../confirm-modal/confirm-modal.model';
import { PopupButtonAction } from '../confirm-modal/popup-button-action.enum';

@Component({
  selector: 'app-reservation-details',
  templateUrl: './reservation-details.component.html',
  styleUrls: ['./reservation-details.component.scss']
})
export class ReservationDetailsComponent implements OnInit {

  ticketReservation: TicketReservationPlugin;
  categoryName: string = "";
  showConfirmation: boolean;
  confirmationTime: number;
  displayReservationTime: Date | string;
  reservationInfo: ReservationPluginInfo;
  reservationGuid: string;
  ticketReservationDeleted: boolean = false;

  constructor(private route: ActivatedRoute,
    public service: ReservationPluginService,
    private translate: TranslateService,
    public dialog: MatDialog
  ) {
    translate.setDefaultLang(navigator.language.substring(0, 2));
    this.route.params.subscribe(params => {
      this.reservationGuid = params['id']
      if (this.reservationGuid) {
        this.service.getReservationData().subscribe(
          data => {
            this.reservationInfo = data;
            this.service.getReservation(this.reservationGuid).subscribe(
              (res) => {
                this.ticketReservation = res;
                this.showConfirmation = true;
                this.setCategoryName();
                this.prepareDisplayReservationTime();
              },
              () => {
              }
            );
          }
        );

      }
    });
  }

  ngOnInit(): void {
  }

  prepareDisplayReservationTime() {

    if (this.isDateType()) {
      this.displayReservationTime = new Date(this.ticketReservation.reservationTime.getFullYear(),
        this.ticketReservation.reservationTime.getMonth(), this.ticketReservation.reservationTime.getDate(),
        this.ticketReservation.reservationTime.getUTCHours(), this.ticketReservation.reservationTime.getMinutes());
    }
    else {
      this.displayReservationTime = this.ticketReservation.reservationTime;
    }
  }

  isDateType(): boolean {
    return typeof this.ticketReservation.reservationTime.getMonth === 'function';
  }

  setCategoryName() {
    let category = this.reservationInfo.categories.find(x => x.id == this.ticketReservation.categoryId);
    if (category) {
      this.categoryName = category.fullName;
    }
  }

  openDeleteReservationPopup() {
    var data: ConfirmModalData = new ConfirmModalData();
    data.confirmCssStyle = 'btn-danger';

    this.translate.get('reservation-cancelation').subscribe((res: string) => {
      data.title = res;
    });
    this.translate.get('cancel-your-reservation').subscribe((res: string) => {
      data.question = res;
    });
    this.translate.get('reservation-cancel').subscribe((res: string) => {
      data.confirm = res;
    });

    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      minWidth: '400px',
      minHeight: '200px',
      data: data
    }
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result.data == PopupButtonAction.SUBMIT) {
        this.service.deleteReservation(this.reservationGuid, (res) => {
          this.ticketReservation = undefined;
          this.ticketReservationDeleted = true;
        }, (res) => {
        })
      }
    });
  }
}
